"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownTreeSelectMemoized = void 0;

var _react = _interopRequireDefault(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _reactDropdownTreeSelect = _interopRequireDefault(require("react-dropdown-tree-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getOptions(data) {
  return data.map(function (_ref) {
    var label = _ref.label,
        value = _ref.value,
        checked = _ref.checked,
        children = _ref.children;
    return {
      label: label,
      value: value,
      checked: checked,
      children: getOptions(children)
    };
  });
}

var DropdownTreeSelectMemoized = /*#__PURE__*/_react["default"].memo(_reactDropdownTreeSelect["default"], function (prevProps, nextProps) {
  var prevOptions = getOptions(prevProps.data);
  var nextOptions = getOptions(nextProps.data);
  return (0, _isEqual["default"])(prevOptions, nextOptions) && (0, _isEqual["default"])(prevProps.readOnly, nextProps.readOnly);
});

exports.DropdownTreeSelectMemoized = DropdownTreeSelectMemoized;